import React, {
  useState,
  Fragment,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import swal from "sweetalert";

import useFullPageLoader from "../../../../hooks/useFullPageLoader";

import PageTitle from "../../../layouts/PageTitle";
import Table from "../../../components/table/ReactTable/Table";

import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import {
  restApi,
  restApi_PD,
} from "../../../../services/wooCommerceRestApi/restApi";
import Toastr from "../../../components/common/Toastr";
import { categoryActions } from "../../../../_store";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";
import emptyImage from "../../../../images/no-image-png-2.png";
import CommonService from "../../../../services/Common/CommonService";

const {
  REACT_APP_API_IMAGE_URL,
  REACT_APP_WORD_PRESS_REST_API,
  REACT_APP_WORD_PRESS_USER_Name,
  REACT_APP_WORD_PRESS_PASSWORD,
  REACT_APP_PD_WORD_PRESS_REST_API,
  REACT_APP_PD_WORD_PRESS_USER_Name,
  REACT_APP_PD_WORD_PRESS_PASSWORD,
} = process.env;

const CategoriesList = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const inputRef = useRef(null);
  const currentUser = useSelector((x) => x.auth.user);
  const categoryList = useSelector((x) => x.category.categoryList);
  const category = useSelector((x) => x.category.category);
  const categoryResponse = useSelector((x) => x.category.categoryResponse);
  const deleteCategoryResponse = useSelector(
    (x) => x.category.deleteCategoryResponse
  );
  const isLoading = useSelector((x) => x.category.isLoading);

  const refImageFormData = useRef("");
  // Table Header

  const CategoriesList_COLUMNS = [
    {
      Header: "Category Name",
      Footer: " Category Name",
      accessor: "CategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Description",
      Footer: "Description",
      accessor: "Description",
      justify: "left",
      Cell: ({ value }) => {
        return (
          <>
            <div style={{ maxWidth: 236 }}> {value}</div>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Created By",
      Footer: "Created By",
      accessor: "CreatedByName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      fieldType: "Date",
      justify: "left",
      //Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "CategoryID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(row.original)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(row.original)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const generateColumns = [
    {
      header: " Category Name",
      dataKey: "CategoryName",
    },
    {
      header: "Description",
      dataKey: "Description",
    },
    {
      header: "Created By",
      dataKey: "CreatedByName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Website",
      dataKey: "Woocommerce",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  const columns = useMemo(() => CategoriesList_COLUMNS, []);

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  //Add data
  const [addFormData, setAddFormData] = useState({
    CategoryID: 0,
    WCCategoryID: 0,
    PDWCCategoryID: 0,
    CategoryName: "",
    Description: "",
    ImageFile: "",
    ImageFilePath: "",
    WCImageURL: "",
    PDWCImageURL: "",
    ProductImageID: 0,
    ImageBase64: "",
    Status: 1,
    IsGemar: false,
    IsPartyDeco: false,
    CreatedBy: currentUser.Id,
  });

  const newFormData = { ...addFormData };

  // const [wordPressData, setWordPressData] = useState({
  //     source_url: '',
  //     pd_source_url: ''
  // });

  useEffect(() => {
    showLoader();
    dispatch(categoryActions.getCategoryAll());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      newFormData[fieldName] = fieldValue;
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }
    setAddFormData(newFormData);
  };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.CategoryID &&
      newFormData.CategoryID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.CategoryID, DeleteType: 1 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Category is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handleChkBoxChangeWooCom = (event) => {
    const { name, checked } = event.target;

    setAddFormData((newFormData) => ({
      ...newFormData,
      [name]: checked ? true : false,
    }));
  };

  const handlePoupClick = () => {
    newFormData.CategoryID = newFormData.WCCategoryID = 0;

    newFormData.CategoryName =
      newFormData.Description =
      newFormData.ImageFile =
      newFormData.ImageFilePath =
      newFormData.ImageBase64 =
      newFormData.WCImageURL =
        "";
    newFormData.Status = 1;
    newFormData.IsGemar = newFormData.IsPartyDeco = false;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    // let newWordPressData = { ...wordPressData }
    // newWordPressData.source_url = "";
    refImageFormData.current = "";
    //setWordPressData(newWordPressData);
    //Toastr('Action successfully executed!', 'success');
  };

  const handleEditClick = (values) => {
    // let newWordPressData = { ...wordPressData }
    // newWordPressData.source_url = "";
    refImageFormData.current = "";
    // setWordPressData(newWordPressData);
    dispatch(
      categoryActions.getCategoryById({ CategoryID: values.CategoryID })
    );
    setOpenModal(true);
    setSubmitted(false);
  };

  // Edit Category
  useEffect(() => {
    if (category && category.CategoryID > 0) {
      newFormData.WCCategoryID = category.WCCategoryID;
      newFormData.PDWCCategoryID = category.PDWCCategoryID;
      newFormData.CategoryID = category.CategoryID;
      newFormData.CategoryName = category.CategoryName;
      newFormData.Description = category.Description;
      newFormData.ImageFile = category.ImageFile;
      newFormData.ImageFilePath = category.ImageFilePath;
      newFormData.ImageBase64 = "";
      newFormData.WCImageURL = category.WCImageURL;
      newFormData.PDWCImageURL = category.PDWCImageURL;
      newFormData.IsGemar = category.IsGemar;
      newFormData.IsPartyDeco = category.IsPartyDeco;
      newFormData.Status = category.Status;
      setAddFormData(newFormData);
    }
  }, [category]);

  const handleDeleteClick = (values) => {
    swal({
      title: "Are you sure, you want to delete this Category?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();

        let Param = { DeleteID: values.CategoryID, DeleteType: 1 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            if (values.IsGemar === true && values.IsPartyDeco === true) {
              restApi
                .delete("products/categories/" + values.WCCategoryID, {
                  // Gemar API
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Party Deco API
                    restApi_PD
                      .delete("products/categories/" + values.PDWCCategoryID, {
                        force: true,
                      })
                      .then((PDResponse) => {
                        if (
                          PDResponse.status === 200 ||
                          PDResponse.status === 201 ||
                          !PDResponse.statusText
                        ) {
                          // Core API
                          dispatch(
                            categoryActions.deleteCategory({
                              CategoryID: values.CategoryID,
                              DeletedBy: currentUser.Id,
                            })
                          );
                        } else {
                          Toastr(
                            "Party Deco : " + response.statusText,
                            "warning"
                          );
                          hideLoader();
                        }
                      })
                      .catch((error) => {
                        hideLoader();
                        Toastr(
                          error.response
                            ? error.response.data.message
                            : "rest Api error",
                          "warning"
                        );
                        console.log(error.response && error.response.data);
                      });
                  } else {
                    Toastr("Gemar : " + response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsGemar === true) {
              // Gemar API
              restApi
                .delete("products/categories/" + values.WCCategoryID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      categoryActions.deleteCategory({
                        CategoryID: values.CategoryID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsPartyDeco === true) {
              // Party Deco API
              restApi_PD
                .delete("products/categories/" + values.PDWCCategoryID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      categoryActions.deleteCategory({
                        CategoryID: values.CategoryID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            }
          } else {
            Toastr("This Category is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteCategoryResponse === 1) {
      hideLoader();
      Toastr("Successfully Deleted", "success");
      dispatch(categoryActions.getCategoryAll());
    } else if (deleteCategoryResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    } else {
      // hideLoader();
    }
  }, [deleteCategoryResponse]);

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const UploadImages = async (e) => {
    const files = e.target.files;
    let file = files[0];

    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validImageTypes.includes(fileType)) {
        hideLoader();
        Toastr("Invalid file format selected", "warning");
        refImageFormData.current = "";
      } else {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 5MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          newFormData.ImageBase64 = base64;
          setAddFormData(newFormData);
          refImageFormData.current = formData;
        }
      }
    }
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (
      !addFormData.CategoryName ||
      (addFormData.IsGemar === false && addFormData.IsPartyDeco === false)
    ) {
      error = true;
    }
    if (!error) {
      if (newFormData.CategoryID > 0) {
        showLoader();

        if (refImageFormData.current) {
          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            AddUpdateDataWithImageGemarAndPA();
          } else if (addFormData.IsGemar === true) {
            AddUpdateDataWithImageGemar();
          } else if (addFormData.IsPartyDeco === true) {
            AddUpdateDataWithImagePA();
          }
        } else {
          let gemar_data = "";
          let PD_data = "";
          if (newFormData.WCImageURL) {
            gemar_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: { src: newFormData.WCImageURL },
            };
          } else {
            gemar_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: null,
            };
          }

          if (newFormData.PDWCImageURL) {
            PD_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: { src: newFormData.PDWCImageURL },
            };
          } else {
            PD_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: null,
            };
          }

          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            if (
              newFormData.WCCategoryID > 0 &&
              newFormData.PDWCCategoryID > 0
            ) {
              UpdateCategory_GemarAndPD(gemar_data, PD_data);
            } else if (newFormData.WCCategoryID > 0) {
              UpdateCategory_UpdateGemarAndAddPD(gemar_data, PD_data);
            } else if (newFormData.PDWCCategoryID > 0) {
              UpdateCategory_AddGemarAndUpdatePD(gemar_data, PD_data);
            }
          } else if (addFormData.IsGemar === true) {
            UpdateCategory_Gemar(gemar_data);
          } else if (addFormData.IsPartyDeco === true) {
            UpdateCategory_PD(PD_data);
          }
        }
      } else {
        showLoader();

        if (refImageFormData.current) {
          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            AddUpdateDataWithImageGemarAndPA();
          } else if (addFormData.IsGemar === true) {
            AddUpdateDataWithImageGemar();
          } else if (addFormData.IsPartyDeco === true) {
            AddUpdateDataWithImagePA();
          }
        } else {
          let gemar_data = {
            name: newFormData.CategoryName,
            description: newFormData.Description,
          };

          let PD_data = {
            name: newFormData.CategoryName,
            description: newFormData.Description,
          };

          if (
            addFormData.IsGemar === true &&
            addFormData.IsPartyDeco === true
          ) {
            AddCategory_GemarAndPD(gemar_data, PD_data);
          } else if (addFormData.IsGemar === true) {
            AddCategory_Gemar(gemar_data);
          } else if (addFormData.IsPartyDeco === true) {
            AddCategory_PD(PD_data);
          }
        }
      }
    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
    }
  };

  // Migration Fun
  /*  const handleMigrationSubmit = (event) => {
    newFormData.PDWCImageURL = "";
    newFormData.WCCategoryID = 0;
    newFormData.WCImageURL = "";
    dispatch(categoryActions.saveCategory(newFormData));
  }; */

  function AddUpdateDataWithImageGemarAndPA() {
    fetch(REACT_APP_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_WORD_PRESS_USER_Name + ":" + REACT_APP_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((gemarData) => {
        fetch(REACT_APP_PD_WORD_PRESS_REST_API, {
          method: "POST",
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                REACT_APP_PD_WORD_PRESS_USER_Name +
                  ":" +
                  REACT_APP_PD_WORD_PRESS_PASSWORD
              ),
          },
          body: refImageFormData.current,
        })
          .then((res) => res.json())
          .then((PDData) => {
            let gemar_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: {
                src: gemarData.source_url,
              },
            };

            let PD_data = {
              name: newFormData.CategoryName,
              description: newFormData.Description,
              image: {
                src: PDData.source_url,
              },
            };
            if (newFormData.CategoryID > 0) {
              if (
                newFormData.WCCategoryID > 0 &&
                newFormData.PDWCCategoryID > 0
              ) {
                UpdateCategory_GemarAndPD(gemar_data, PD_data);
              } else if (newFormData.WCCategoryID > 0) {
                UpdateCategory_UpdateGemarAndAddPD(gemar_data, PD_data);
              } else if (newFormData.PDWCCategoryID > 0) {
                UpdateCategory_AddGemarAndUpdatePD(gemar_data, PD_data);
              }
            } else {
              AddCategory_GemarAndPD(gemar_data, PD_data);
            }
          })
          .catch((err) => {
            hideLoader();
            console.log(err);
          });
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddUpdateDataWithImageGemar() {
    fetch(REACT_APP_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_WORD_PRESS_USER_Name + ":" + REACT_APP_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((gemarData) => {
        let gemar_data = {
          name: newFormData.CategoryName,
          description: newFormData.Description,
          image: {
            src: gemarData.source_url,
          },
        };
        if (newFormData.CategoryID > 0) {
          UpdateCategory_Gemar(gemar_data);
        } else {
          AddCategory_Gemar(gemar_data);
        }
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddUpdateDataWithImagePA() {
    fetch(REACT_APP_PD_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_PD_WORD_PRESS_USER_Name +
              ":" +
              REACT_APP_PD_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((PDData) => {
        let PD_data = {
          name: newFormData.CategoryName,
          description: newFormData.Description,
          image: {
            src: PDData.source_url,
          },
        };

        if (newFormData.CategoryID > 0) {
          UpdateCategory_PD(PD_data);
        } else {
          AddCategory_PD(PD_data);
        }
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddCategory_GemarAndPD(gemar_data, PD_data) {
    restApi
      .post("products/categories", gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCCategoryID = response.data.id;
          newFormData.WCImageURL = response.data.image
            ? response.data.image.src
            : "";

          restApi_PD
            .post("products/categories", PD_data) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCCategoryID = PDResponse.data.id;
                newFormData.PDWCImageURL = PDResponse.data.image
                  ? PDResponse.data.image.src
                  : "";
                dispatch(categoryActions.saveCategory(newFormData));
              } else {
                hideLoader();
                Toastr(PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "term_exists") {
                  msg = "Party Deco Category name already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function AddCategory_Gemar(gemar_data) {
    restApi
      .post("products/categories", gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCCategoryID = response.data.id;
          newFormData.WCImageURL = response.data.image
            ? response.data.image.src
            : "";
          if (newFormData.CategoryID === 0 || !newFormData.CategoryID) {
            newFormData.PDWCCategoryID = 0;
            newFormData.PDWCImageURL = "";
          }

          dispatch(categoryActions.saveCategory(newFormData));
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function AddCategory_PD(PD_data) {
    restApi_PD
      .post("products/categories", PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCCategoryID = PDResponse.data.id;
          newFormData.PDWCImageURL = PDResponse.data.image
            ? PDResponse.data.image.src
            : "";
          if (newFormData.CategoryID === 0 || !newFormData.CategoryID) {
            newFormData.WCCategoryID = 0;
            newFormData.WCImageURL = "";
          }
          dispatch(categoryActions.saveCategory(newFormData));
        } else {
          hideLoader();
          Toastr(PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();

        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateCategory_GemarAndPD(gemar_data, PD_data) {
    restApi
      .put("products/categories/" + newFormData.WCCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCCategoryID = response.data.id;
          if (response.data.image && response.data.image.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }

          restApi_PD
            .put("products/categories/" + newFormData.PDWCCategoryID, PD_data) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCCategoryID = PDResponse.data.id;
                if (PDResponse.data.image && PDResponse.data.image.src) {
                  newFormData.PDWCImageURL = PDResponse.data.image.src;
                } else {
                  newFormData.PDWCImageURL = "";
                }

                // Core WMS API
                dispatch(categoryActions.saveCategory(newFormData));
              } else {
                hideLoader();
                Toastr("Party Deco :" + PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "term_exists") {
                  msg = "Party Deco Category name already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "Party Deco rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr("Party Deco :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  function UpdateCategory_UpdateGemarAndAddPD(gemar_data, PD_data) {
    restApi
      .put("products/categories/" + newFormData.WCCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCCategoryID = response.data.id;
          if (response.data.image && response.data.image.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }

          //PD
          AddCategory_PD(PD_data);
        } else {
          hideLoader();
          Toastr("Party Deco :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateCategory_AddGemarAndUpdatePD(gemar_data, PD_data) {
    restApi_PD
      .put("products/categories/" + newFormData.PDWCCategoryID, PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCCategoryID = PDResponse.data.id;

          if (PDResponse.data.image && PDResponse.data.image.src) {
            newFormData.PDWCImageURL = PDResponse.data.image.src;
          } else {
            newFormData.PDWCImageURL = "";
          }

          //Gemar
          AddCategory_Gemar(gemar_data);
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateCategory_Gemar(gemar_data) {
    restApi
      .put("products/categories/" + newFormData.WCCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCCategoryID = response.data.id;
          if (response.data.image && response.data.image.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }
          newFormData.PDWCImageURL = "";
          newFormData.PDWCCategoryID = 0;
          // Core WMS API
          dispatch(categoryActions.saveCategory(newFormData));
        } else {
          hideLoader();
          Toastr("Gemar :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  function UpdateCategory_PD(PD_data) {
    restApi_PD
      .put("products/categories/" + newFormData.PDWCCategoryID, PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCCategoryID = PDResponse.data.id;

          if (PDResponse.data.image && PDResponse.data.image.src) {
            newFormData.PDWCImageURL = PDResponse.data.image.src;
          } else {
            newFormData.PDWCImageURL = "";
          }
          newFormData.WCImageURL = "";
          newFormData.WCCategoryID = 0;
          // Core WMS API
          dispatch(categoryActions.saveCategory(newFormData));
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco Category name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  // category Add And Update  handleSubmit //
  useEffect(() => {
    if (categoryResponse === 1) {
      hideLoader();
      Toastr("Category Successfully Added", "success");
      dispatch(categoryActions.getCategoryAll());
      setOpenModal(false);
    } else if (categoryResponse === 2) {
      hideLoader();
      Toastr("Category Successfully Updated", "success");
      dispatch(categoryActions.getCategoryAll());
      setOpenModal(false);
    } else if (categoryResponse === -1) {
      hideLoader();
      Toastr("Category name already exists ", "warning");
    }
  }, [categoryResponse]);

  const handleClickPDF = () => {
    let title = "Category List";
    const columnStyles = {
      CategoryName: { halign: "left", cellWidth: 70 },
      Description: { halign: "left", cellWidth: 70 },
      CreatedByName: { halign: "left", cellWidth: 40 },
      CreatedDate: { halign: "left", cellWidth: 22 },
      StatusName: { halign: "center", cellWidth: 18 },
      Woocommerce: { halign: "left", cellWidth: 40 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Category";
    let generateExcelColumns = [
      "Category Name",
      "Description",
      "Created By",
      "Created Date",
      "Website",
      "Status",
    ];
    let new_categoryList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          CategoryName: obj.CategoryName,
          Description: obj.Description,
          CreatedByName: obj.CreatedByName,
          CreatedDate: obj.CreatedDateString,
          Woocommerce: obj.Woocommerce,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_categoryList, generateExcelColumns, title);
  };
  const handleClickImageClose = () => {
    newFormData.ImageFilePath =
      newFormData.ImageBase64 =
      newFormData.WCImageURL =
      newFormData.PDWCImageURL =
        "";
    setAddFormData(newFormData);
    inputRef.current.value = null;
    refImageFormData.current = "";
    hideLoader();
  };

  return (
    <>
      <PageTitle activeMenu="Category" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Category List</h4>
          {/* <Button
                        variant="primary"
                        className="mb-2 me-2"
                        // onClick={() => setLargeModal(true)}
                        onClick={handlePoupClick}
                    >

                    </Button> */}
          <div className="float-sm-end">
            {categoryList && categoryList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={categoryList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.CategoryID > 0 ? "Edit Category" : "Add Category"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  {" "}
                  Category Name<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !newFormData.CategoryName && "border-danger"
                    }`}
                    autocomplete="off"
                    name="CategoryName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.CategoryName}
                    placeholder="Category Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Description</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={"form-control"}
                    autocomplete="off"
                    name="Description"
                    required="required"
                    onChange={handleChange}
                    placeholder="Description"
                    value={newFormData.Description}
                    maxLength={200}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Upload/Add Image(jpeg/jpg/png)
                </label>

                <div className="col-md-9 mb-3">
                  {newFormData.ImageFilePath || newFormData.ImageBase64 ? (
                    <>
                      <Fragment>
                        <div className="card">
                          <div className="card-header">
                            <span className="float-right">
                              {" "}
                              <i
                                onClick={() => handleClickImageClose()}
                                className="fas fa-times productImageClose"
                              ></i>
                            </span>
                          </div>

                          <img
                            style={{ height: "170px" }}
                            className="card-img-top"
                            src={
                              !newFormData.ImageBase64
                                ? REACT_APP_API_IMAGE_URL +
                                  newFormData.ImageFilePath
                                : newFormData.ImageBase64
                            }
                            alt="Card image cap"
                          />
                        </div>
                      </Fragment>
                    </>
                  ) : (
                    <div className="card">
                      {newFormData.ImageFilePath || newFormData.ImageBase64 ? (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={
                            !newFormData.ImageBase64
                              ? REACT_APP_API_IMAGE_URL +
                                newFormData.ImageFilePath
                              : newFormData.ImageBase64
                          }
                          alt="Card image cap"
                        />
                      ) : (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={emptyImage}
                          alt="Card image cap"
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className="input-group mb-3">
                  <div className="form-file">
                    <input
                      type="file"
                      ref={inputRef}
                      onChange={(event) => UploadImages(event)}
                      className={`custom-file-input form-control`}
                    />
                  </div>
                  <span className="input-group-text">Upload</span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                {newFormData.CategoryID > 0 ? (
                  // Update
                  <>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                      disabled={
                        newFormData.CategoryID > 0 &&
                        newFormData.WCCategoryID > 0
                      }
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                        disabled={
                          newFormData.CategoryID > 0 &&
                          newFormData.PDWCCategoryID > 0
                        }
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </>
                ) : (
                  // Add
                  <>
                    <input
                      className={`form-check-input ${
                        submitted &&
                        addFormData.IsGemar === false &&
                        addFormData.IsPartyDeco === false &&
                        "border-danger"
                      }`}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className={`form-check-input ${
                          submitted &&
                          addFormData.IsGemar === false &&
                          addFormData.IsPartyDeco === false &&
                          "border-danger"
                        }`}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            //  onClick={handleMigrationSubmit}
            className="btn btn-primary"
          >
            {newFormData.CategoryID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default CategoriesList;
